export default "__VITE_ASSET__NxKkEUfM__"